const link_list = {
    routePath: 'invitees',
    actionName: 'count',
    iconClass: 'fa-solid fa-user-plus',
    title: 'Recent Active Invites',
    search: '',
    sort: {
        order: 'asc',
        column: 'date_entered',
    },
    perPage: 10,
}
export default {link_list }